module.exports = __webpack_public_path__ + "assets/lines_rule.ec25725d.svg";